document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-main-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (!open) closeSubmenus();
    });

    const submenuButtons = menu.querySelectorAll('[data-submenu-toggle]');
    const setSubmenu = (item, open) => {
      item.classList.toggle('is-expanded', open);
      item.querySelector('[data-submenu-toggle]').setAttribute('aria-expanded', String(open));
    };
    const closeSubmenus = (except) => {
      submenuButtons.forEach((button) => {
        const item = button.closest('.main-nav__item');
        if (item !== except) setSubmenu(item, false);
      });
    };
    const closeMainMenu = () => {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      closeSubmenus();
    };
    const hasHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    submenuButtons.forEach((button) => {
      const item = button.closest('.main-nav__item');
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        closeSubmenus(item);
        setSubmenu(item, open);
      });
      item.addEventListener('mouseenter', () => {
        if (hasHover()) {
          closeSubmenus(item);
          setSubmenu(item, true);
        }
      });
      item.addEventListener('mouseleave', () => {
        if (hasHover() && !item.contains(document.activeElement)) setSubmenu(item, false);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setSubmenu(item, false);
      });
    });

    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) {
        closeSubmenus();
        if (!toggle.contains(event.target) && menu.classList.contains('is-open')) closeMainMenu();
      }
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const activeItem = document.activeElement.closest('.main-nav__item--has-children');
        const submenuWasOpen = !!menu.querySelector('.main-nav__item.is-expanded');
        closeSubmenus();
        if (activeItem && submenuWasOpen) activeItem.querySelector('[data-submenu-toggle]').focus();
        else if (menu.classList.contains('is-open')) { closeMainMenu(); toggle.focus(); }
      }
    });
  }
  const picker = document.querySelector('[data-category-picker]');
  if (picker) {
    const button = picker.querySelector('[data-category-toggle]');
    const setPicker = (open) => {
      picker.classList.toggle('is-expanded', open);
      button.setAttribute('aria-expanded', String(open));
    };
    button.addEventListener('click', () => {
      setPicker(button.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', (event) => {
      if (!picker.contains(event.target)) setPicker(false);
    });
    picker.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setPicker(false);
        button.focus();
      }
    });
    picker.addEventListener('focusout', (event) => {
      if (!picker.contains(event.relatedTarget)) setPicker(false);
    });
  }
  const gallery = document.querySelector('[data-product-gallery]');
  const showGalleryImage = (src, alt, imageId) => {
    if (!gallery || !src) return;
    const mainImage = gallery.querySelector('[data-main-image]');
    if (!mainImage) return;
    mainImage.src = src;
    mainImage.alt = alt || '';
    mainImage.removeAttribute('srcset');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.setAttribute('aria-pressed', String(imageId
        ? thumb.dataset.imageId === imageId
        : thumb.dataset.gallerySrc === src));
    });
  };
  if (gallery) {
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showGalleryImage(thumbnail.dataset.gallerySrc, thumbnail.dataset.galleryAlt, thumbnail.dataset.imageId);
      });
    });
  }
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const colors = form && form.querySelector('[data-color-options]');
    const colorPosition = colors ? Number(colors.dataset.colorPosition) : 0;
    const colorButtons = colors ? [...colors.querySelectorAll('[data-color-value]')] : [];
    const optionGroups = form ? [...form.querySelectorAll('[data-variant-option]')] : [];
    const variants = [...select.options];
    const positions = [1, 2, 3];
    // HTML data-option-1 is exposed as dataset['option-1'], not dataset.option1.
    const optionValue = (variant, position) =>
      variant.dataset[`option-${position}`] ?? variant.dataset[`option${position}`] ?? '';
    const chooseVariant = (position, value) => {
      const previous = select.selectedOptions[0];
      const matches = variants.filter((variant) => optionValue(variant, position) === value);
      const exact = matches.find((variant) => positions.every((index) =>
        index === position || optionValue(variant, index) === optionValue(previous, index)));
      return exact || matches.find((variant) => variant.dataset.available === 'true') || matches[0];
    };
    const update = (updateUrl) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const price = document.getElementById(select.dataset.priceTarget);
      const button = document.getElementById(select.dataset.buttonTarget);
      if (price) {
        const currentPrice = price.querySelector('[data-current-price]');
        const comparePrice = price.querySelector('[data-compare-price]');
        if (currentPrice) currentPrice.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
        }
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.innerHTML = available ? 'Add to cart <span aria-hidden="true">→</span>' : 'Sold out';
      }
      if (colors) {
        const selectedColor = optionValue(option, colorPosition);
        const label = colors.querySelector('[data-selected-color]');
        if (label) label.textContent = selectedColor;
        colorButtons.forEach((color) => {
          color.setAttribute('aria-pressed', String(color.dataset.colorValue === selectedColor));
          const matching = variants.filter((variant) => optionValue(variant, colorPosition) === color.dataset.colorValue);
          color.dataset.available = String(matching.some((variant) => variant.dataset.available === 'true'));
          color.title = matching.some((variant) => variant.dataset.available === 'true') ? '' : 'Sold out';
        });
      }
      optionGroups.forEach((group) => {
        const position = Number(group.dataset.optionPosition);
        const selectedValue = optionValue(option, position);
        const selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = selectedValue;
        group.querySelectorAll('[data-option-value]').forEach((choice) => {
          const value = choice.dataset.optionValue;
          const matching = variants.filter((variant) =>
            optionValue(variant, position) === value && positions.every((index) =>
              index === position || optionValue(variant, index) === optionValue(option, index)));
          const available = matching.some((variant) => variant.dataset.available === 'true');
          choice.setAttribute('aria-pressed', String(value === selectedValue));
          choice.dataset.available = String(available);
          choice.disabled = !matching.length;
          choice.title = matching.length && !available ? 'Sold out' : '';
        });
      });
      if (gallery) {
        const selectedColor = colorButtons.find((color) => color.getAttribute('aria-pressed') === 'true');
        const colorImage = selectedColor ? selectedColor.dataset : {};
        const variantSrc = option.dataset.imageSrc;
        const colorSrc = colorImage.colorImageSrc;
        showGalleryImage(
          variantSrc || colorSrc || gallery.dataset.defaultImageSrc,
          variantSrc ? option.dataset.imageAlt : (colorSrc ? colorImage.colorImageAlt : gallery.dataset.defaultImageAlt),
          variantSrc ? option.dataset.imageId : (colorSrc ? colorImage.colorImageId : gallery.dataset.defaultImageId)
        );
      }
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.delete('option_values');
        url.searchParams.set('variant', select.value);
        window.history.replaceState(window.history.state, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    colorButtons.forEach((color) => {
      color.addEventListener('click', () => {
        const next = chooseVariant(colorPosition, color.dataset.colorValue);
        if (!next) return;
        select.value = next.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    optionGroups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      group.querySelectorAll('[data-option-value]').forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.disabled) return;
          const next = chooseVariant(position, choice.dataset.optionValue);
          if (!next) return;
          select.value = next.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
    update(false);
    if (form) form.classList.add('is-enhanced');
  });
});
